<template>
  <div class="project-container">
    <div class="page-header">
      <h2>项目管理</h2>
      <p>管理公司项目信息</p>
    </div>
    
    <div class="content-area">
      <el-card>
        <template #header>
          <div class="card-header">
            <span>项目列表</span>
            <div class="header-actions">
              <el-button type="primary" size="small" @click="handleAdd">新建项目</el-button>
              <el-button type="success" size="small" @click="handleRefresh">刷新数据</el-button>
            </div>
          </div>
        </template>
        
        <!-- 搜索区域 -->
        <div class="search-area">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="项目名称">
              <el-input v-model="searchForm.name" placeholder="请输入项目名称" clearable />
            </el-form-item>
            <el-form-item label="项目负责人">
              <el-select v-model="searchForm.user" placeholder="请选择负责人" style="width: 180px;" clearable>
                <el-option
                  v-for="emp in employeeList"
                  :key="emp.id"
                  :label="emp.name"
                  :value="emp.id" />
              </el-select>
            </el-form-item>
           
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 项目列表 -->
        <el-table
          :data="projectList"
          v-loading="loading"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column prop="name" label="项目名称" width="200" show-overflow-tooltip />
          <el-table-column prop="user" label="项目负责人" width="180">
            <template #default="scope">
              <div class="user-list">
                <el-tag
                  v-for="userId in getUserIds(scope.row.user)"
                  :key="userId"
                  size="small"
                  class="user-tag">
                  {{ getEmployeeName(userId) }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
     
          <el-table-column prop="location" label="位置信息" width="180" show-overflow-tooltip />
          <el-table-column prop="client_contact_person" label="甲方联系人" width="120" />
          <el-table-column prop="client_contact_phone" label="甲方联系电话" width="140" />
          <el-table-column prop="decoration_contact_person" label="精装单位联系人" width="140" />
          <el-table-column prop="decoration_contact_phone" label="精装单位联系电话" width="160" />
          <el-table-column prop="remarks" label="项目备注" show-overflow-tooltip />
          <el-table-column prop="createtime" label="创建时间" width="180">
            <template #default="scope">
              {{ formatDate(scope.row.createtime) }}
            </template>
          </el-table-column>
          <el-table-column prop="updatetime" label="更新时间" width="180">
            <template #default="scope">
              {{ formatDate(scope.row.updatetime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260" fixed="right">
            <template #default="scope">
               <el-button size="small" type="primary" @click="handleEnterProject(scope.row)">进入项目</el-button>
              <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
             
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-area">
          <el-pagination
            v-model:current-page="pagination.currentPage"
            v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </el-card>
    </div>

    <!-- 添加/编辑项目对话框 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      width="600px"
      @close="handleDialogClose">
      <el-form
        ref="projectFormRef"
        :model="projectForm"
        :rules="projectRules"
        label-width="120px">
        <el-form-item label="项目名称" prop="name">
          <el-input v-model="projectForm.name" placeholder="请输入项目名称" />
        </el-form-item>
        <el-form-item label="项目负责人" prop="user">
          <el-select
            v-model="projectForm.user"
            multiple
            placeholder="请选择项目负责人"
            style="width: 100%">
            <el-option
              v-for="emp in employeeList"
              :key="emp.id"
              :label="emp.name"
              :value="emp.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="位置信息">
          <div class="location-input-group">
            <el-input 
              v-model="projectForm.location" 
              placeholder="请输入位置信息或点击地图选择" 
              readonly
            />
            <el-button 
              type="primary" 
              @click="showMapPicker = true"
              class="map-select-btn"
            >
              地图选择
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="甲方联系人">
          <el-input v-model="projectForm.client_contact_person" placeholder="请输入甲方联系人" />
        </el-form-item>
        <el-form-item label="甲方电话">
          <el-input v-model="projectForm.client_contact_phone" placeholder="请输入甲方联系电话" />
        </el-form-item>
        <el-form-item label="精装单位联系人">
          <el-input v-model="projectForm.decoration_contact_person" placeholder="请输入精装单位联系人" />
        </el-form-item>
        <el-form-item label="精装单位电话">
          <el-input v-model="projectForm.decoration_contact_phone" placeholder="请输入精装单位联系电话" />
        </el-form-item>
        <el-form-item label="项目备注">
          <el-input
            v-model="projectForm.remarks"
            type="textarea"
            :rows="4"
            placeholder="请输入项目备注信息" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 位置选择器对话框 -->
    <el-dialog
      title="选择位置"
      v-model="showMapPicker"
      width="800px"
      @close="showMapPicker = false">
      <GaodeLocationPicker
        v-model="projectForm.location"
        @confirm="handleMapConfirm"
        @cancel="showMapPicker = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import GaodeLocationPicker from '../components/GaodeLocationPicker.vue'

export default {
  name: 'ProjectPage',
  components: {
    GaodeLocationPicker
  },
  data() {
    return {
      loading: false,
      projectList: [],
      employeeList: [],
      selectedProjects: [],
      searchForm: {
        name: '',
        user: '',
       
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新建项目',
      submitting: false,
      showMapPicker: false,
      projectForm: {
        id: '',
        name: '',
        user: [],
     
        location: '',
        client_contact_person: '',
        client_contact_phone: '',
        decoration_contact_person: '',
        decoration_contact_phone: '',
        remarks: ''
      },
      projectRules: {
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 2, max: 255, message: '项目名称长度在 2 到 255 个字符', trigger: 'blur' }
        ],
        user: [
          { required: true, message: '请选择项目负责人', trigger: 'change' }
        ],
        moeny: [
          { required: true, message: '请输入项目金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '项目金额必须大于等于0', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    projectFormRef() {
      return this.$refs.projectFormRef
    }
  },
  mounted() {
    // 先加载员工列表，再加载项目列表
    this.getEmployeeList().then(() => {
      this.getProjectList()
    })
  },
  methods: {
    // 获取员工列表
    async getEmployeeList() {
      try {
        const response = await this.$axios.get('/api/employee/getlist')
        if (response.code === 1) {
          this.employeeList = response.data || []
        } else {
          ElMessage.error(response.msg || '获取员工列表失败')
        }
      } catch (error) {
        console.error('获取员工列表失败:', error)
        ElMessage.error('获取员工列表失败')
      }
    },

    // 获取项目列表
    async getProjectList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        
        const response = await this.$axios.get('/api/project/getlist', { params })
        if (response.code === 1) {
          this.projectList = response.data || []
          this.pagination.total = response.total || 0
        } else {
          ElMessage.error(response.msg || '获取项目列表失败')
        }
      } catch (error) {
        console.error('获取项目列表失败:', error)
        ElMessage.error('获取项目列表失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.getProjectList()
    },

    // 重置搜索
    handleReset() {
      this.searchForm = {
        name: '',
        user: '',
        location: ''
      }
      this.pagination.currentPage = 1
      this.getProjectList()
    },

    // 新建项目
    handleAdd() {
      this.dialogTitle = '新建项目'
      this.projectForm = {
        id: '',
        name: '',
        user: [],
        moeny: 0,
        location: '',
        client_contact_person: '',
        client_contact_phone: '',
        decoration_contact_person: '',
        decoration_contact_phone: '',
        remarks: ''
      }
      this.dialogVisible = true
    },

    // 编辑项目
    handleEdit(row) {
      this.dialogTitle = '编辑项目'
      this.projectForm = {
        ...row,
        user: this.getUserIds(row.user) // 将字符串转换为数组
      }
      this.dialogVisible = true
    },

    // 删除项目
    async handleDelete(row) {
      try {
        await ElMessageBox.confirm(
          `确定要删除项目 "${row.name}" 吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        
        const response = await this.$axios.post('/api/project/delete', { id: row.id })
        if (response.code === 1) {
          ElMessage.success('删除成功')
          this.getProjectList()
        } else {
          ElMessage.error(response.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除项目失败:', error)
          ElMessage.error('删除失败')
        }
      }
    },

    // 刷新数据
    handleRefresh() {
      this.getProjectList()
      ElMessage.success('数据已刷新')
    },

    // 提交表单
    async handleSubmit() {
      if (!this.projectFormRef) return

      try {
        await this.projectFormRef.validate()
        this.submitting = true

        // 将负责人数组转换为逗号分隔的字符串
        const submitData = {
          ...this.projectForm,
          user: this.projectForm.user.join(',')
        }

        let response
        if (this.projectForm.id) {
          // 编辑项目
          response = await this.$axios.post('/api/project/edit', submitData)
        } else {
          // 新建项目
          response = await this.$axios.post('/api/project/add', submitData)
        }

        if (response.code === 1) {
          ElMessage.success(this.projectForm.id ? '编辑成功' : '新建成功')
          this.dialogVisible = false
          this.getProjectList()
        } else {
          ElMessage.error(response.msg || '操作失败')
        }
      } catch (error) {
        if (error.response) {
          ElMessage.error(error.response.msg || '操作失败')
        }
      } finally {
        this.submitting = false
      }
    },

    // 对话框关闭
    handleDialogClose() {
      this.projectFormRef?.resetFields()
    },

    // 地图选择确认
    handleMapConfirm() {
      this.showMapPicker = false
      ElMessage.success('位置选择成功')
    },

    // 选择项目
    handleSelectionChange(selection) {
      this.selectedProjects = selection
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.getProjectList()
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getProjectList()
    },

    // 获取员工名称
    getEmployeeName(userId) {
      const emp = this.employeeList.find(item => item.id == userId)
      return emp ? emp.name : '未知员工'
    },

    // 将负责人字符串转换为数组
    getUserIds(userString) {
      if (!userString) return []
      return userString.split(',').filter(id => id.trim())
    },

    // 格式化金额
    formatMoney(money) {
      if (!money) return '0.00'
      return parseFloat(money).toFixed(2)
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },

    // 进入项目详情
    handleEnterProject(row) {
      this.$router.push(`/project/detail/${row.id}`)
    }
  }
}
</script>

<style scoped>
.project-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
}

.page-header p {
  margin: 5px 0 0 0;
  color: #909399;
  font-size: 14px;
}

.content-area {
  margin-top: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.search-area {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.pagination-area {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.user-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.user-tag {
  margin: 2px;
}

.location-input-group {
  display: flex;
  gap: 10px;
}

.location-input-group .el-input {
  flex: 1;
}

.map-select-btn {
  white-space: nowrap;
}
</style>
